import constants from '@/app-configs/constants'

export default [
  {
    path: '/payments',
    name: 'payments-list',
    component: () => import('@/views/payments/List.vue'),
    meta: {
      pageTitle: 'DEBTIA_PAYMENTS',
      breadcrumb: [
        {
          text: 'DEBTIA_PAYMENTS',
          active: true,
        },
      ],
      action: constants.action.permissionUserView,
      resource: constants.resource.user,
    },
  },
  {
    path: '/payments-breakdown',
    name: 'payments-breakdown',
    component: () => import('@/views/payments/PaymentsBreakdownPage.vue'),
    meta: {
      pageTitle: 'DEBTIA_PAYMENTS',
      breadcrumb: [
        {
          text: 'DEBTIA_PAYMENTS',
          active: true,
        },
      ],
      action: constants.action.permissionUserView,
      resource: constants.resource.user,
    },
  },
  {
    path: '/payments-breakdown/:id',
    name: 'payments-breakdown-id',
    component: () => import('@/views/payments/PaymentsBreakdownPage.vue'),
    meta: {
      pageTitle: 'DEBTIA_PAYMENTS',
      breadcrumb: [
        {
          text: 'DEBTIA_PAYMENTS',
          active: true,
        },
      ],
      action: constants.action.permissionUserView,
      resource: constants.resource.user,
    },
  },
  {
    path: '/payments/admin-settings',
    name: 'payments-admin-settings',
    component: () => import('@/views/paymentsadminsettings/AdminSettings.vue'),
    meta: {
      pageTitle: 'DEBTIA_ADMIN_SETTINGS',
      breadcrumb: [
        {
          text: 'DEBTIA_ADMIN_SETTINGS',
          active: true,
        },
      ],
      action: constants.action.permissionUserView,
      resource: constants.resource.user,
    },
  },
]
